enum ChatChannelType  {
  PublicWithMembership = 'public_with_membership',
  PublicWithoutMembership = 'public_without_membership',
}
export default Object.freeze(ChatChannelType);

